import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})

export class IpService {
  // Primary and fallback IP API URLs
  private ipApiUrls = [
    "https://api.ipify.org?format=json",
    "https://api64.ipify.org?format=json",
    "https://ipinfo.io/json"
  ];

  constructor() {}

  async getUserIp(): Promise<{ ip: string | null }> {
    // Try each API URL in sequence until one works
    for (const apiUrl of this.ipApiUrls) {
      try {
        const response = await fetch(apiUrl, { mode: "cors" });

        // Check if the response was successful
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        // Different APIs return IP in different formats
        const ip = data.ip || (data.hasOwnProperty('ip') ? data.ip : null);
        
        if (ip) {
          return { ip };
        }
      } catch (error) {
        console.error(`Error fetching IP address from ${apiUrl}:`, error);
        // Continue to the next API if this one failed
      }
    }
    
    // If all APIs failed
    console.error("Error fetching IP address: All API endpoints failed");
    return { ip: null };
  }

  async getIp(): Promise<string | null> {
    const result = await this.getUserIp();
    if (result.ip !== null) {
      return result.ip;
    } else {
      console.warn('Failed to fetch IP address');
      return null;
    }
  }
}
